import { useQuery } from "react-query";
import { getAMBestRating } from "../../../../actions/CarrierAgreementMgmt/Carrier";

export const useGetAMBestRating = () => {
  return useQuery("GetAMBestRating", getAMBestRating, {
    refetchOnWindowFocus: false,
  });
};
